'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VehiclePurchaseDate;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _splitField = require('../components/split-field');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function VehiclePurchaseDate(props) {
  return _react2.default.createElement(_splitField.Date, {
    noDay: true,
    name: 'vehiclePurchaseDate',
    helpText: 'If your car is not yet purchased, please select this month.',
    label: 'When was the car purchased? (mm/yyyy)'
  });
}